import AsyncStorage from '@react-native-async-storage/async-storage'
import { isNil } from 'lodash'
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { buildStorageKey } from 'shared/storage'
import { useUser } from 'users/queries/detail'

export function useStoredState<S>(
  key: string
): [S | undefined, Dispatch<SetStateAction<S | undefined>>] {
  const [storedValue, setStoredValue] = useState<S | undefined>()
  const { data: user } = useUser()

  useEffect(() => {
    AsyncStorage.getItem(buildStorageKey(key, user?.id))
      .then(json => {
        setStoredValue(json ? JSON.parse(json) : null)
      })
      .catch(console.error)
  }, [key, user?.id])

  const setValue = useCallback(
    async (valueOrFunction: SetStateAction<S | undefined>) => {
      try {
        const value =
          valueOrFunction instanceof Function
            ? valueOrFunction(storedValue)
            : valueOrFunction

        setStoredValue(value)

        if (!isNil(value)) {
          await AsyncStorage.setItem(
            buildStorageKey(key, user?.id),
            JSON.stringify(value)
          ).catch(err => console.error(err))
        } else {
          await AsyncStorage.removeItem(buildStorageKey(key, user?.id))
        }
      } catch (error) {
        console.log(error)
      }
    },
    [key, storedValue, user?.id]
  )

  return [storedValue, setValue]
}
